import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Layout from "../components/Layout";
import Card from "../components/Card";
import PageHeader from "../components/PageHeader";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Lottie from "react-lottie";
import noDatafound from "../assets/images/Animation - 1721025848612.json";

import {
  msiAPi,
  msiVisionGamesAPi,
  DigitizeMisApi,
  WonderMindMisApi,
  KickwinMisApi,
} from "../Data/api";

const services = [
  { name: "kiddoCraze", code: "KC", api: msiAPi },
  { name: "VisionGames", code: "VG", api: msiVisionGamesAPi },
  { name: "DigitizeAi", code: "DA", api: DigitizeMisApi },
  { name: "WonderMind", code: "WM", api: WonderMindMisApi },
  { name: "KickWin", code: "KW", api: KickwinMisApi },
];

const Mis = () => {
  const [dateRange, setDateRange] = useState([
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    new Date(),
  ]);

  const [startDate, endDate] = dateRange;

  const [allServiceData, setAllServiceData] = useState({});

  const formatDate = (date) => {
    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const fetchData = async (start, end, apiUrl) => {
    try {
      const response = await axios.post(
        `${apiUrl}?from=${formatDate(start)}&to=${formatDate(end)}`,
      );

      if (Array.isArray(response.data.results)) {
        return response.data.results.map((item) =>
          Object.fromEntries(
            Object.entries(item).map(([key, value]) => [key, value ?? 0]),
          ),
        );
      }

      return [];
    } catch (error) {
      console.log("MIS API ERROR", error);

      return [];
    }
  };

  const fetchAllData = async () => {
    if (!startDate || !endDate) return;

    const result = {};

    for (const service of services) {
      result[service.name] = await fetchData(startDate, endDate, service.api);
    }

    setAllServiceData(result);
  };

  useEffect(() => {
    fetchAllData();

    const interval = setInterval(fetchAllData, 300000);

    return () => clearInterval(interval);
  }, [startDate, endDate]);

  return (
    <Layout>
      <div className="flex flex-col items-center w-full">
        {/* <div className="w-full px-4">
          <div className="card mb-6 p-5">
            <PageHeader title="MIS Report" />

            <div className="mt-4">
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  setDateRange(update);
                }}
                isClearable={false}
                dateFormat="yyyy-MM-dd"
                className="w-full px-4 py-3 border rounded-xl shadow-sm"
              />
            </div>
          </div>
        </div> */}

        <div className="w-full relative z-50">
          <div className="card mb-6 animate-fade-in bg-white border-0 shadow-sm relative overflow-visible z-50">
            {/* Center MIS Heading */}
            <div className="flex justify-center w-full">
              <PageHeader center={true} title="MIS Report"  />
            </div>

            {/* Center Date Range Picker */}
            <div className="mt-2 mb-4 flex justify-center w-full z-[100] relative">
              <div className="relative shadow-sm rounded-xl">
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  isClearable={false}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select Date Range"
                  className="w-full sm:w-80 px-5 py-3.5 text-center text-slate-700 bg-neutral-50/50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary focus:bg-white transition-all font-medium cursor-pointer hover:border-slate-300 relative z-[100]"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-2 relative z-10">
          {services.map((service) => {
            const data = allServiceData[service.name] || [];

            return (
              <Card key={service.code} className="mb-6 animate-fade-in">
                <div className="card-heading border-b border-slate-100 pb-4">
                  <h2 className="text-xl md:text-2xl font-extrabold text-slate-800 tracking-tight">
                    {service.name.toUpperCase()} MIS REPORT
                  </h2>
                  <span className="section-label">MIS Data</span>
                </div>

                {data.length === 0 ? (
                  <div className="flex flex-col items-center justify-center py-12 bg-slate-50/50 rounded-xl mt-4">
                    <Lottie
                      options={{
                        autoplay: true,
                        animationData: noDatafound,
                      }}
                      style={{
                        width: "150px",
                        height: "150px"
                      }}
                    />
                    <p className="text-slate-500 font-medium mt-4">No data found for this period</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto mt-4 w-full">
                    <DataTable value={data} paginator rows={5} className="data-table-custom">
                      <Column field="mis_date" header="MIS Date" className="whitespace-nowrap" />
                      <Column field="subscriptions" header="Subscriptions" />
                      <Column field="renewals" header="Renewals" />
                      <Column field="unsubscriptions" header="Unsubscriptions" />
                      <Column field="sub_revenue" header="Sub Revenue" />
                      <Column field="ren_revenue" header="Ren Revenue" />
                      <Column field="total_revenue" header="Total Revenue" />
                    </DataTable>
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default Mis;
